import { db } from "@db";
import type { GnomuxFile } from "@db/objects";
import type { CreateNucleotideSequenceResult } from "./createNucleotideSequence";

export async function groupAsCollection(
  results: CreateNucleotideSequenceResult[],
  name: string,
  ownerId: string,
): Promise<GnomuxFile> {
  const fileIdsToRemove = results.map((r) => r.file.id);
  const sequenceIds = results.map((r) => r.sequence.id);

  const collection: GnomuxFile = {
    id: crypto.randomUUID(),
    name,
    content: sequenceIds,
    isLocked: false,
    parent: "root",
    type: "GnomuxSequenceCollection",
    createdAt: new Date(),
    ownerId,
  };

  await db.transaction("rw", db.objects, async () => {
    await db.objects.bulkDelete(fileIdsToRemove);
    await db.objects.put(collection);
  });

  return collection;
}
